import { render } from "./BInput.vue?vue&type=template&id=72e86b4c"
import script from "./BInput.vue?vue&type=script&lang=js"
export * from "./BInput.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__